// extracted by mini-css-extract-plugin
module.exports = {"icon":"TabTitle_icon__3gVG4","iconFA":"TabTitle_iconFA__R-xrU","counter":"TabTitle_counter__1kvUK"};